import { useContext, useMemo } from 'react';

import { LayoutContext } from '../../baseLayout/provider';

const MemberCenterDialog = ({ headBuriedPoint }) => {
  const { resourceData } = useContext(LayoutContext);
  const { projectConfigVO } = resourceData;

  const dataList = useMemo(
    () => [
      {
        id: 1,
        title: '我的优惠券',
        op: 'member_coupon',
        href: `${projectConfigVO?.lcscMemberUrl}/member/couponList.html`,
        spm: 'yhq',
      },
      {
        id: 2,
        title: '备货提单',
        href: `${projectConfigVO?.lcscMemberUrl}/member/pick/goods/manage.html`,
        spm: 'bh',
      },
      {
        id: 3,
        title: '我的发票',
        op: 'member_invoice',
        href: `${projectConfigVO?.lcscMemberUrl}/member/invoice/schedule.html`,
        spm: 'fp',
      },
      {
        id: 4,
        title: '预付余额',
        op: 'member_balance',
        href: `${projectConfigVO?.lcscMemberUrl}/member/wallet/manage.html`,
        spm: 'ye',
      },
      {
        id: 5,
        title: '我的收藏',
        op: 'member_collect',
        href: `${projectConfigVO?.lcscMemberUrl}/member/favorite.html`,
        spm: 'sc',
      },
      {
        id: 6,
        title: '售后投诉',
        op: 'member_complain',
        href: `${projectConfigVO?.lcscMemberUrl}/member/complain.html`,
        spm: 'ts',
      },
    ],
    [resourceData]
  );

  function tabClick(data) {
    if (data.op) {
      headBuriedPoint(data.op, data.href);
    }
  }

  return (
    <ul className="items-center px-[8px] py-[4px] flex flex-wrap" data-spm="hd">
      {dataList.map((data, idx) => (
        <li
          key={data.id}
          className={`${[4, 5].includes(idx) ? 'mb-[0]' : 'mb-[16px]'} ${[1, 3, 5].includes(idx) ? 'text-center' : ''} basis-1/2 odd:border-[#E4E4E4] odd:border-r odd:border-solid`}
        >
          <a
            target="_blank"
            className="text-[14px] text-black leading-[20px]"
            aria-label={data.title}
            href={data.href}
            onClick={() => {
              tabClick(data);
            }}
            data-spm={data.spm}
          >
            {data.title}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default MemberCenterDialog;
